var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMicOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12.4412 4.01264c1.6883-.35019 3.4293-.35019 5.1176 0 .7302.15146 1.2925.74317 1.4137 1.48771l.0613.37599c.5138 3.15626.5138 6.37636 0 9.53266l-.0613.376c-.1212.7445-.6835 1.3362-1.4137 1.4877-1.6883.3502-3.4293.3502-5.1176 0-.7302-.1515-1.2925-.7432-1.4137-1.4877l-.0613-.376c-.5138-3.1563-.5138-6.3764 0-9.53266l.0613-.37599c.1212-.74454.6835-1.33625 1.4137-1.48771zm4.7776 1.67941c-1.464-.30366-2.9736-.30366-4.4376 0-.0428.00886-.0757.04349-.0828.08706l-.0612.376c-.4838 2.97165-.4838 6.00349 0 8.97509l.0612.376c.0071.0436.04.0782.0828.0871 1.464.3036 2.9736.3036 4.4376 0 .0427-.0089.0757-.0435.0828-.0871l.0612-.376c.4838-2.9716.4838-6.00344 0-8.97509l-.0612-.376c-.0071-.04357-.0401-.0782-.0828-.08706z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.97807 13.794c.46303-.0664.89158.2597.95719.7285l.50863 3.6335c.13742.9817.90619 1.7493 1.87781 1.8749 3.1062.4017 6.2504.4017 9.3566 0 .9716-.1256 1.7404-.8932 1.8778-1.8749l.5086-3.6335c.0657-.4688.4942-.7949.9572-.7285.4631.0665.7852.5003.7196.969l-.5086 3.6335c-.2444 1.7462-1.6118 3.1115-3.34 3.3349-1.3438.1738-2.6944.2756-4.0461.3057v4.6057c0 .4734-.3791.8572-.8468.8572-.4676 0-.8467-.3838-.8467-.8572v-4.6057c-1.3518-.0301-2.7024-.1319-4.0462-.3057-1.72816-.2234-3.09555-1.5887-3.33999-3.3349l-.50863-3.6335c-.06561-.4687.25656-.9025.71959-.969z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicOn);
export default __webpack_public_path__ + "static/media/icon_mic_on.b703eaed90a34715c99d5d32a49e7d52.svg";
export { ForwardRef as ReactComponent };